import { RootState } from '@/store/root-state';
import { createSelector } from '@reduxjs/toolkit';

const selectCampaignTemplatesState = (state: RootState) => state.campaignTemplates;

export const selectCampaignTemplates = createSelector(selectCampaignTemplatesState, (state) => state.templates);
export const selectLoadingCampaignTemplates = createSelector(
  selectCampaignTemplatesState,
  (state) => state.loadingTemplates
);
export const selectErrorLoadingCampaignTemplates = createSelector(
  selectCampaignTemplatesState,
  (state) => state.errorLoadingTemplates
);

export const selectCampaignTemplateCategories = createSelector(selectCampaignTemplates, (templates) => {
  const categories = new Set<string>();
  templates.forEach((template) => {
    if (template.category) {
      categories.add(template.category);
    }
  });
  return Array.from(categories).sort();
});

export const selectCampaignTemplateSuites = createSelector(selectCampaignTemplates, (templates) => {
  const categoryMap = new Map<string, typeof templates>();
  templates.forEach((template) => {
    if (!template.category) return;
    const categoryTemplates = categoryMap.get(template.category) || [];
    categoryTemplates.push(template);
    categoryMap.set(template.category, categoryTemplates);
  });

  return Array.from(categoryMap.entries())
    .map(([category, categoryTemplates]) => ({
      category,
      templates: categoryTemplates,
      templateCount: categoryTemplates.length,
    }))
    .sort((a, b) => a.category.localeCompare(b.category));
});
